import { HekateDisplayField } from 'www-shared';

/** A wrapper around a vue component to be shown as in a unified signup screen */
export default class UnifiedSignupScreenComponent {
  public readonly displayField: HekateDisplayField;

  constructor({
    displayField,
  }: {
    displayField: HekateDisplayField,
  }) {
    this.displayField = displayField;
  }
}
